module.exports = __webpack_public_path__ + "img/eye.dc77dd82.svg";